import { forwardRef } from 'react'
import style from './style.module.scss'

interface IMediaInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const MediaInput = forwardRef<HTMLInputElement, IMediaInputProps>((props, ref) => {
  return (
    <div className={style.media_input}>
      <input type="file" id="media_input" ref={ref} {...props} />
    </div>
  )
})

export default MediaInput
